import { useModalLayout } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalLayoutProvider'
import { Portal } from 'components/Portal/Portal'
import { PropsWithChildren } from 'react'

export const ModalSubmitContainer = ({ children }: PropsWithChildren) => {
  const { submitContainer } = useModalLayout()

  return <Portal container={submitContainer}>{children}</Portal>
}
